/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
// export const urls = "https://test.api.future.welaiedu.cn/evaluate"
// export const uplUrl = "https://test.api.future.welaiedu.cn/future"
// export const fuUrl = "https://test.api.future.welaiedu.cn/future"
// export const zxLive = "http://beta.zxkt.welaiedu.cn/#/live?id="
// export const zxIndex = "http://beta.zxkt.welaiedu.cn/#/index?id="


export const uplUrl = "https://api.future.welaiedu.cn/future"
export const urls = "https://api.future.welaiedu.cn/evaluate"
export const fuUrl = "https://api.future.welaiedu.cn/future"
export const zxLive = "http://zxkt.welaiedu.cn/#/live?id="
export const zxIndex = "http://zxkt.welaiedu.cn/#/index?id="

import { POST, BASE_URL, down } from '../api/index'
//退出登录
export function UserLogout() {
	return POST(urls + '/user/logout', '', 'post', '')
}
//修改密码
export function modifyPassWord(params) {
	return POST(urls + '/usercenter/modify-password-by-old', params, 'post', '', '4')
}
//获取登陆用户信息
export function usercenterinfo() {
	return POST(urls + '/usercenter/get-info', '', 'get', '')
}
//获取学校详细信息
export function schoolgetinfo(params) {
	return POST(urls + '/school/get-info', params, 'get', '')
}
//用户登录接口
export function userlogin(params) {
	return POST(urls + '/user/login', params, 'post', '', 4)
}
//获取登陆用户信息
export function usercentergetinfo(params) {
	return POST(urls + '/usercenter/get-info', params, 'get', '')
}
// 获取权限菜单
export function treeByRole(params) {
	return POST(urls + '/menu/tree-by-role', params, 'get', '')
}

// 获取优课类型列表
export function getCourseTypeList(params) {
	return POST(fuUrl + `/course/coursetype/list`, params, 'get')
}
// 获取优课列表
export function getCourseList(params) {
	return POST(fuUrl + `/course/list`, params, 'get')
}
// 删除课程
export function deleteCourse(params) {
	return POST(fuUrl + `/course/` + params.id, {}, 'delete')
}
// 获取学校列表
export function getSchoolList(params) {
	return POST(urls + `/school/list`, params, 'get')
}
// 获取名师列表
export function getTeacherList(params) {
	return POST(urls + `/teacher/list`, params, 'get')
}
// 字典
export function dictcode(params) {
	return POST(urls + `/dict/code`, params, 'get', '')
}
//分类
export function courseclassify() {
	return POST(fuUrl + `/course/classify/list?parentId=0&groupId=1`, '', 'get', '')
}
// 获取教材列表
export function getBookList(params) {
	return POST(fuUrl + `/book/list`, params, 'get')
}
// 获取年级列表
export function getGradeList(params) {
	return POST(urls + `/grade/gradelist`, params, 'get')
}
// 获取学科列表
export function getSubjectList(params) {
	return POST(urls + `/subject/list`, params, 'get')
}
// 获取教材章节树
export function getBookTreeList(params) {
	return POST(fuUrl + `/book/getchaptertree`, params, 'get')
}
//上传附件
export function uploadFile(params) {
	return POST(urls + `/file/file-upload`, params)
}
//新增或编辑课程信息
export function saveCourse(params) {
	return POST(fuUrl + `/course`, params)
}
// 获取上传资源类型
export function getResTypeList(params) {
	return POST(fuUrl + `/res/types/list`, params, 'get')
}
// 删除课时
export function deleteLesson(params) {
	return POST(fuUrl + `/course/lesson/` + params.id, {}, 'delete')
}
//课程详情-根据课时ID获取推流地址
export function lessongetPushUrl(params) {
	return POST(fuUrl + `/lesson/getPushUrl`, params, 'get', '')
}
//新增或编辑课时
export function saveCourseLesson(params) {
	return POST(fuUrl + `/course/lesson`, params)
}
// 获取课程详情
export function getCourseInfo(params) {
	return POST(fuUrl + `/course/` + params.id, {}, 'get')
}
// 分页获取学校列表
export function schoolList(params) {
	return POST(urls + `/school/list`, params, 'get', '')
}
// 获取授权课程列表
export function courseLists(params) {
	return POST(fuUrl + `/course/limit/getCourseListBySchoolId`, params, 'get', '')
}
// 课程添加与移除
export function batchOperate(params) {
	return POST(fuUrl + '/course/limit/batchOperate', params, 'post', '')
}
// 获取资源列表
export function resList(params) {
	return POST(fuUrl + '/res/list', params, 'get', '')
}
// 字典
export function dictCode(params) {
	return POST(urls + '/dict/code', params, 'get', '')
}
// 批量审核通过/不通过
export function batchReview(params) {
	return POST(fuUrl + '/res/batch-review', params, 'post', '')
}
// 资源置顶
export function setTop(params) {
	return POST(fuUrl + '/res/set-top', params, 'post', '', '4')
}
// 资源类型-新增/编辑
export function resTypes(params) {
	return POST(fuUrl + '/res/types', params, 'post', '')
}

// 资源类型-删除
export function deleteResTypes(params) {
	return POST(fuUrl + `/res/types/` + params.id, '', 'delete')
}
// 资讯类型 添加
export function saveArticleType(params) {
	return POST(fuUrl + '/group/article/saveArticleType', params, 'post', '')
}
// 根据集团校ID查询动态类型
export function queryTypeList(params) {
	return POST(fuUrl + '/group/article/queryTypeList', params, 'get', '')
}
// 动态类型删除
export function deleteType(params) {
	return POST(fuUrl + '/group/article/type/' + params.id, '', 'delete', '')
}
// 保存动态
export function saveArticleInfo(params) {
	return POST(fuUrl + '/group/article/saveArticleInfo', params, 'post', '')
}
// 分页查询动态
export function queryArticleList(params) {
	return POST(fuUrl + '/group/article/queryArticleList', params, 'get', '')
}
// 查询动态详情
export function queryArticleInfo(params) {
	return POST(fuUrl + '/group/article/queryArticleInfo', params, 'get', '')
}
// 动态资讯删除
export function deleteDynamic(params) {
	return POST(fuUrl + '/group/article/' + params.id, '', 'delete', '')
}
// 分页查询申报录课记录列表信息
export function selectDeclareList(params) {
	return POST(fuUrl + '/declare/selectDeclareList', params, 'get', '')
}
// 查询学校所有课程
export function getSubjectBySchoolId(params) {
	return POST(urls + '/subject/getSubjectBySchoolId', params, 'get', '')
}
// 删除上传的回放视频
export function delDeclarePlaybackVideo(params) {
	return POST(fuUrl + '/declare/delDeclarePlaybackVideo', params, 'delete', '4')
}
// 上传申报录课回放视频列表
export function uploadDeclareVideo(params) {
	return POST(fuUrl + '/declare/uploadDeclarePlaybackVideo', params, 'post', '')
}
// 根据申报录课主键ID查询申报录课信息
export function selectByPrimaryKey(params) {
	return POST(fuUrl + '/declare/selectByPrimaryKey', params, 'get', '')
}
// 导出word文档
export function dexportTeacher(params, name) {
	if (params.beginTime) {
		return down(fuUrl + '/declare/watchLiveImport?beginTime=' + params.beginTime + '&endTime=' + params.endTime, 'get', name)
	} else {
		return down(fuUrl + '/declare/watchLiveImport?timeRange=' + params.timeRange, 'get', name)
	}
	// return down(fuUrl + '/declare/watchLiveImport' ,params, 'get', name)
}
export function watchStatistics(params) {
	return POST(fuUrl + '/declare/watchLiveRecordStatistics', params, 'get', '')
}
// 重置密码
export function resetPassword(params) {
	return POST(urls + '/usercenter/reset-password', params, 'get', '')
}
// 编辑申报录课回放视频
export function updatebackVideo(params) {
	return POST(fuUrl + '/declare/updateDeclarePlaybackVideo', params, 'post', '')
}
// 小组列表携带成员
export function getUserList(params) {
  return POST(fuUrl + '/course/team/getUserList', params, 'get', '')
}
export function getTeamUsersList(params) {
  return POST(fuUrl + '/course/team/resources/getUserList', params, 'get', '')
}
export function downloadTeamUsersImportTemplate() {
  return down(fuUrl + '/course/team/resources/usersImportTemplate', 'get', '小组成员导入模板', '1')
}
export function deleteTeamUsersList(ids) {
  return POST(fuUrl + '/course/team/resources/userList/' + ids, '', 'DELETE', '')
}
export function changeBaseSchool(params) {
  return POST(urls + '/school/base', params, 'put', '')
}
// 直播间观看记录查询
export function liveRoomWatchRecord(params) {
	return POST(fuUrl + '/declare/liveRoomWatchRecord', params, 'get', '')
}
// 导出观看统计
export function exportLive(params,name) {
	return down(fuUrl + '/declare/exportCourseWatchCount?lessonId=' + params.lessonId , 'get', name, 1)
}
// 听课感受-获取听课感受（评论-分页）
export function feelingList(params) {
	return POST(fuUrl + '/lesson/feeling/list', params, 'get', '')
}
// 批量审核通过/不通过 讨论
export function feelingBatchReview(params) {
	return POST(fuUrl + '/lesson/feeling/batch-review', params, 'post', '')
}
// 整学期按照课程维度统计导出
export function exportStatis(params,name) {
	return down(fuUrl + '/declare/exportCourseStatistics?timeRange=' + params.timeRange + '&beginTime=' +  params.beginTime+ '&endTime=' +  params.endTime, 'get', name, 1)
}
// 设置置顶
export function feelingSetTop(params) {
	return POST(fuUrl + '/lesson/feeling/setTop', params, 'post', '','4')
}
// 分页查询OSS对象
export function queryVideoList(params) {
	return POST(fuUrl + '/aliyunOss/queryVideoList', params, 'get', '')
}
// 课程列表导出
export function exportCourseList(params,name) {
	return down(fuUrl + '/course/export?courseTypeid=' + params.courseTypeid + '&subjectId=' + params.subjectId+'&gradeId=' + params.gradeId+'&courseState=' + params.courseState+ '&courseClassify=' + params.courseClassify+ '&courseLimit=' + params.courseLimit + '&groupId=' + params.groupId, 'get', name, 1)
}



// WEBPACK FOOTER //
// ./src/api/home.js